import { Align, asset, IAssetHandle, inject, Layout, SoundResource, SpineResource, view, ViewFixedSize } from "@spawn/core";
import { ReelSoundAssets } from "@spawn/core-assets";
import { RevealSymbolView } from "@spawn/reveal";
import { GameConfigService, NetworkService, ReelController, ThreeSymbolRule } from "@spawn/slot-machine";
import Victor from "victor";
import { NrgAttentionSpinAddon } from "../addons/attentionSpinAddon";
import { BaseSymbolTypes } from "../services/symbolService";
import { ExtendedReelSetView } from "./reelSetView";
import { ReelTeaserAddon } from "./reelTeaserAddon";
import { NrgReelView } from "./reelView";

@view
export class ReelSetContainerView extends ViewFixedSize {
	@asset(SpineResource) public readonly attentionSpinAnimation!: IAssetHandle<SpineResource>;
	@asset(SoundResource) public readonly attentionSpinSound!: IAssetHandle<SoundResource>;
	@asset(SoundResource) public readonly teaserSound!: IAssetHandle<SoundResource>;

	@inject private readonly reelSoundAssets!: ReelSoundAssets;
	@inject private readonly reelController!: ReelController;
	@inject private readonly gameConfigService!: GameConfigService;
	@inject private readonly networkService!: NetworkService;

	private readonly reelSet: ExtendedReelSetView;

	constructor() {
		super({ layout: new Layout(Align.CenterHorizontal, Align.CenterVertical) });

		this.reelSet = this.createReelSet();
		this.addChild(this.reelSet);
	}

	protected createReelSet(): ExtendedReelSetView {
		const { spaceBetweenReels, symbolSize, visibleSymbols, reelCount, swingOffSymbols, swingOnSymbols } =
			this.gameConfigService.defaultConfig();

		const reelSetView = new ExtendedReelSetView({
			size: new Victor(reelCount * symbolSize.x + (reelCount - 1) * spaceBetweenReels, visibleSymbols * symbolSize.y),
			layout: new Layout(Align.CenterHorizontal, Align.CenterVertical),
			spinSounds: this.reelSoundAssets.soundsReelsRunning(),
			stopSounds: this.reelSoundAssets.soundsReelStop(),
			quickstopSound: this.reelSoundAssets.quickStopSound(),
			smartMask: true,
			name: "BaseGame",
		});

		for (let i = 0; i < reelCount; i++) {
			const reelView = new NrgReelView({
				reelIndex: i,
				symbolSize,
				visibleSymbols,
				swingOffSymbols,
				swingOnSymbols,
				symbolViewConstructor: RevealSymbolView,
				initReelsNetworkStatePath: this.networkService.resuming ? "initialResumeReels" : "slotGameBase.reels",
				addons: [
					new NrgAttentionSpinAddon({
						reelIndex: i,
						rules: [new ThreeSymbolRule(BaseSymbolTypes.Scatter)],
						sounds: new Array(reelCount).fill(this.attentionSpinSound()),
						animations: new Array(reelCount).fill(this.attentionSpinAnimation()),
						skinName: "attentionspin",
					}),
					new ReelTeaserAddon({
						teaserSoundResource: this.teaserSound,
					}),
				],
			});

			reelView.position = new Victor(symbolSize.x * i + spaceBetweenReels * i, 0);

			reelSetView.addReel(reelView);
		}

		this.reelController.setReelSetsActive("BaseGame");

		return reelSetView;
	}
}
